import { useQuery } from "@tanstack/react-query";
import { fetchAdapterHealth } from "../../lib/api.js";

export function HealthBar() {
  const q = useQuery({
    queryKey: ["adapter-health"],
    queryFn: fetchAdapterHealth,
    refetchInterval: 5_000,
  });

  const adapters = q.data ?? {};
  const entries = Object.entries(adapters);

  return (
    <div className="flex items-center gap-2 text-xs">
      {entries.length === 0 && <span className="text-zinc-500">…</span>}
      {entries.map(([name, h]) => (
        <span
          key={name}
          className={
            "flex items-center gap-1 rounded px-1.5 py-0.5 font-mono " +
            (h.connected
              ? "bg-accent/10 text-accent"
              : "bg-bear/10 text-bear")
          }
          title={h.reason ?? ""}
        >
          <span
            className={
              "h-1.5 w-1.5 rounded-full " +
              (h.connected ? "bg-accent" : "bg-bear")
            }
          />
          {name}
        </span>
      ))}
    </div>
  );
}
